{
  "PROFILE_SETTINGS": {
    "LINK": "Налаштування облікового запису",
    "TITLE": "Налаштування облікового запису",
    "BTN_TEXT": "Оновити обліковий запис",
    "DELETE_AVATAR": "Видалити аватар",
    "AVATAR_DELETE_SUCCESS": "Аватар був успішно видалений",
    "AVATAR_DELETE_FAILED": "Виникла помилка під час видалення аватару, будь ласка, спробуйте ще раз",
    "UPDATE_SUCCESS": "Ваш профіль було успішно оновлено",
    "PASSWORD_UPDATE_SUCCESS": "Ваш пароль було успішно змінено",
    "AFTER_EMAIL_CHANGED": "Ваш обліковий запис було успішно оновлено. Будь ласка, увійдіть знову, оскільки ваші дані були змінені",
    "FORM": {
      "PICTURE": "Фото профілю",
      "AVATAR": "Зображення облікового запису",
      "ERROR": "Будь ласка, виправте помилки форми",
      "REMOVE_IMAGE": "Видалити",
      "UPLOAD_IMAGE": "Завантажити зображення",
      "UPDATE_IMAGE": "Оновити зображення",
      "PROFILE_SECTION": {
        "TITLE": "Анкета",
        "NOTE": "Ваша електронна адреса - це ваша ідентифікація і використовується для входу."
      },
      "SEND_MESSAGE": {
        "TITLE": "Комбінація клавіш для надсилання повідомлень",
        "NOTE": "Ви можете обрати гарячу клавішу (Enter або Cmd/Ctrl+Enter) на основі ваших вподобань.",
        "UPDATE_SUCCESS": "Ваші налаштування були успішно оновлені",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Надсилати повідомлення, натиснувши клавішу Enter замість кнопки надсилання."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Надсилати повідомлення, натиснувши комбінацію Cmd/Ctrl + Enter замість кнопки надсилання."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Customize the look and feel of your Chatwoot dashboard.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "За замовчуванням",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "LANGUAGE": {
          "TITLE": "Preferred Language",
          "NOTE": "Choose the language you want to use.",
          "UPDATE_SUCCESS": "Your Language settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the language settings, please try again",
          "USE_ACCOUNT_DEFAULT": "Use account default"
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Підпис особистого повідомлення",
        "NOTE": "Створити унікальний підпис повідомлення для кожного повідомлення, яке ви надсилаєте з будь-якої поштової скриньки. Ви також можете включити вбудоване зображення, яке підтримується у живому чаті, електронній пошті та API-поштових скриньках.",
        "BTN_TEXT": "Зберегти підпис повідомлення",
        "API_ERROR": "Не вдалося зберегти підпис! Повторіть спробу",
        "API_SUCCESS": "Підпис успішно збережено",
        "IMAGE_UPLOAD_ERROR": "Не вдалося завантажити зображення! Повторіть спробу",
        "IMAGE_UPLOAD_SUCCESS": "Зображення успішно додано. Будь ласка, натисніть на кнопку Зберегти, щоб зберегти підпис",
        "IMAGE_UPLOAD_SIZE_ERROR": "Зображення має бути менше {size}Мб",
        "INLINE_IMAGE_WARNING": "Pasted inline images were removed. Please use the image upload button to add images to your signature."
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Підпис повідомлення",
        "ERROR": "Підпис повідомлення не може бути порожнім",
        "PLACEHOLDER": "Вставити свій персональний підпис повідомлення тут."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Пароль",
        "NOTE": "Оновлення вашого пароля призведе до скидання ваших записів про вхід на інших пристроях.",
        "BTN_TEXT": "Змінити пароль"
      },
      "SECURITY_SECTION": {
        "TITLE": "Security",
        "NOTE": "Manage additional security features for your account.",
        "MFA_BUTTON": "Manage Two-Factor Authentication"
      },
      "SESSIONS_SECTION": {
        "TITLE": "Active Sessions",
        "NOTE": "These are the devices currently logged in to your account.",
        "CURRENT": "Current session",
        "REVOKE": "Revoke",
        "REVOKE_SUCCESS": "Session revoked successfully",
        "REVOKE_ERROR": "Unable to revoke session. Please try again.",
        "FETCH_ERROR": "Unable to fetch sessions. Please try again.",
        "LAST_ACTIVE": "Last active",
        "UNKNOWN_DEVICE": "Unknown device"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Ключ доступу",
        "NOTE": "Цей ключ можна використовувати, якщо ви створюєте API-інтеграцію",
        "PAID_PLAN_NOTE": "API access tokens are available on paid plans.",
        "COPY": "Копіювати",
        "RESET": "Reset",
        "CONFIRM_RESET": "Are you sure?",
        "CONFIRM_HINT": "Click again to confirm",
        "RESET_SUCCESS": "Access token regenerated successfully",
        "RESET_ERROR": "Unable to regenerate access token. Please try again"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "Нiчого",
          "MINE": "Призначено",
          "ALL": "Всі",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Сповіщення про події для розмов",
          "NONE": "Нiчого",
          "ASSIGNED": "Призначені розмови",
          "ALL_CONVERSATIONS": "Всі розмови"
        },
        "DEFAULT_TONE": {
          "TITLE": "Тон сигналу:"
        },
        "CONDITIONS": {
          "TITLE": "Умови оповіщення:",
          "CONDITION_ONE": "Надсилати аудіосповіщення тільки якщо вікно браузера не активне",
          "CONDITION_TWO": "Надсилати сповіщення кожні 30 секунд, поки всі призначені розмови не будуть переглянуті"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Детальніше"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Сповіщення електронною поштою",
        "NOTE": "Тут оновлюються налаштування повідомлень електронною поштою",
        "CONVERSATION_ASSIGNMENT": "Надсилати сповіщення коли бесіду призначають мені",
        "CONVERSATION_CREATION": "Надсилати сповіщення при створенні нової бесіди",
        "CONVERSATION_MENTION": "Надсилати сповіщення електронною поштою, коли вас згадують в розмові",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Надсилати сповіщення при створенні нового повідомлення у призначеній розмові",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Надсилати поштові листи, коли нове повідомлення створюється в призначеній розмові",
        "SLA_MISSED_FIRST_RESPONSE": "Надсилати сповіщення електронною поштою, коли в бесіді пропущено першу відповідь SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Надсилати сповіщення електронною поштою, коли в бесіді пропущено наступну відповідь SLA",
        "SLA_MISSED_RESOLUTION": "Надсилати сповіщення електронною поштою, коли бесіда пропускає SLA розширення"
      },
      "NOTIFICATIONS": {
        "TITLE": "Налаштування сповіщень",
        "TYPE_TITLE": "Тип сповіщення",
        "EMAIL": "Email",
        "PUSH": "Push-сповіщення",
        "TYPES": {
          "CONVERSATION_CREATED": "Діалог створено",
          "CONVERSATION_ASSIGNED": "Розмова призначена вам",
          "CONVERSATION_MENTION": "Ви згадані в розмові",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Нове повідомлення створено в призначеній розмові",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Створено нове повідомлення в розмові з учасниками",
          "SLA_MISSED_FIRST_RESPONSE": "Розмова пропускає першу відповідь SLA",
          "SLA_MISSED_NEXT_RESPONSE": "Розмова пропускає наступну відповідь SLA",
          "SLA_MISSED_RESOLUTION": "Розмова пропускає SLA розширення"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them"
      },
      "API": {
        "UPDATE_SUCCESS": "Налаштування сповіщень для вашого акаунту оновлено успішно",
        "UPDATE_ERROR": "Виникла помилка під час оновлення налаштувань, будь ласка, спробуйте ще раз"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push-сповіщення",
        "NOTE": "Оновіть ваші налаштування push-сповіщень тут",
        "CONVERSATION_ASSIGNMENT": "Надсилати push-повідомлення, коли мені призначено розмову",
        "CONVERSATION_CREATION": "Надсилати push-повідомлення, коли створюється нова розмова",
        "CONVERSATION_MENTION": "Надсилати push-повідомлення, коли вас згадують в розмові",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Надсилати push-повідомлення, коли нове повідомлення створюється в призначеній розмові",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Надсилати push-повідомлення, коли нове повідомлення створюється в призначеній розмові",
        "HAS_ENABLED_PUSH": "Ви увімкнули push для цього браузера.",
        "REQUEST_PUSH": "Увімкнути push-сповіщення",
        "SLA_MISSED_FIRST_RESPONSE": "Надсилати push-повідомлення, коли в розмові пропущено першу відповідь SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Надсилати push-повідомлення, коли в розмові пропущено наступну відповідь SLA",
        "SLA_MISSED_RESOLUTION": "Надсилати push-повідомлення, коли бесіда пропускає SLA розширення"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Зображення облікового запису"
      },
      "NAME": {
        "LABEL": "Ваше повне ім'я",
        "ERROR": "Будь ласка, введіть своє повне ім'я",
        "PLACEHOLDER": "Будь ласка, введіть своє повне ім'я"
      },
      "DISPLAY_NAME": {
        "LABEL": "Ім'я для відображення",
        "ERROR": "Будь ласка, введіть коректне ім'я",
        "PLACEHOLDER": "Будь ласка, введіть ім'я, яке буде показано у розмовах"
      },
      "AVAILABILITY": {
        "LABEL": "Присутність",
        "STATUS": {
          "ONLINE": "В мережі",
          "BUSY": "Зайнятий",
          "OFFLINE": "Не в мережі"
        },
        "SET_AVAILABILITY_SUCCESS": "Доступу успішно встановлено",
        "SET_AVAILABILITY_ERROR": "Не вдалося налаштувати доступність, будь ласка, спробуйте ще раз",
        "IMPERSONATING_ERROR": "Cannot change availability while impersonating a user"
      },
      "EMAIL": {
        "LABEL": "Ваша адреса електронної пошти",
        "ERROR": "Будь ласка, введіть коректну адресу електронної пошти",
        "PLACEHOLDER": "Введіть адресу електронної пошти, її буде видно в бесідах"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Поточний пароль",
        "ERROR": "Будь ласка, введіть поточний пароль",
        "PLACEHOLDER": "Будь ласка, введіть поточний пароль"
      },
      "PASSWORD": {
        "LABEL": "Новий пароль",
        "ERROR": "Будь ласка, введіть пароль довжиною 6 або більше символів",
        "PLACEHOLDER": "Будь ласка, введіть новий пароль"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Підвердіть новий пароль",
        "ERROR": "Підтвердження пароля має відповідати паролю",
        "PLACEHOLDER": "Будь ласка, введіть новий пароль ще раз"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Змінити",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "SELECTOR_SUBTITLE": "Виберіть обліковий запис із наступного списку",
    "PROFILE_SETTINGS": "Profile settings",
    "YEAR_IN_REVIEW": "Year in Review",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "CHANGELOG": "Changelog",
    "LOGOUT": "Log out"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "днів пробного періоду залишилося.",
    "TRAIL_BUTTON": "Придбати зараз",
    "DELETED_USER": "Видалений користувач",
    "EMAIL_VERIFICATION_PENDING": "Схоже, ви ще не підтвердили адресу електронної пошти. Будь ласка, перевірте вашу поштову скриньку для підтвердження.",
    "RESEND_VERIFICATION_MAIL": "Повторно надіслати листа з підтвердженням",
    "EMAIL_VERIFICATION_SENT": "Лист для підтвердження було надіслано. Будь ласка, перевірте вашу електронну пошту.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Обліковий запис призупинено",
      "MESSAGE": "Ваш обліковий запис призупинено. Будь ласка, зверніться до служби підтримки для отримання додаткової інформації."
    },
    "NO_ACCOUNTS": {
      "TITLE": "No account found",
      "MESSAGE_CLOUD": "You are not part of any accounts right now. If you think this is a mistake, please reach out to our support team.",
      "MESSAGE_SELF_HOSTED": "You are not part of any accounts right now. Please reach out to your administrator.",
      "LOGOUT": "Log out"
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Копіювати",
      "CODEPEN": "Відкрити у CodePen",
      "COPY_SUCCESSFUL": "Код скопійований в буфер обміну"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Показати більше",
      "SHOW_LESS": "Показати менше"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Звантажити",
      "UPLOADING": "Завантажується...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Ця історія більше не доступна.",
      "INSTAGRAM_STORY_REPLY": "Відповів(-ла) на вашу історію:"
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Дивитись на карті"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Додати"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Перевірка...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Додати канал"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Зараз переглядається:",
    "SWITCH": "Перемкнути",
    "INBOX_VIEW": "Перегляд вхідних",
    "CONVERSATIONS": "Бесіди",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "Всі розмови",
    "MENTIONED_CONVERSATIONS": "Згадування",
    "PARTICIPATING_CONVERSATIONS": "Підключені агенти",
    "UNATTENDED_CONVERSATIONS": "Не зв'язаний",
    "REPORTS": "Звіти",
    "SETTINGS": "Налаштування",
    "CONTACTS": "Контакти",
    "ACTIVE": "Активний",
    "COMPANIES": "Компанії",
    "ALL_COMPANIES": "All Companies",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_OVERVIEW": "Огляд",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "CAPTAIN_TOOLS": "Tools",
    "CAPTAIN_SCENARIOS": "Scenarios",
    "CAPTAIN_PLAYGROUND": "Playground",
    "CAPTAIN_INBOXES": "Вхідні",
    "CAPTAIN_SETTINGS": "Налаштування",
    "HOME": "Головна",
    "AGENTS": "Агенти",
    "AGENT_BOTS": "Боти",
    "AUDIT_LOGS": "Журнал аудиту",
    "INBOXES": "Вхідні",
    "NOTIFICATIONS": "Сповіщення",
    "CANNED_RESPONSES": "Швидкі відповіді",
    "INTEGRATIONS": "Інтеграції",
    "DATA": "Data",
    "PROFILE_SETTINGS": "Налаштування облікового запису",
    "ACCOUNT_SETTINGS": "Налаштування акаунту",
    "APPLICATIONS": "Додатки",
    "LABELS": "Мітки",
    "CUSTOM_ATTRIBUTES": "Свої атрибути",
    "AUTOMATION": "Автоматизація",
    "MACROS": "Макроси",
    "TEAMS": "Команди",
    "BILLING": "Біллінг",
    "CUSTOM_VIEWS_FOLDER": "Папки",
    "CUSTOM_VIEWS_SEGMENTS": "Сегменти",
    "ALL_CONTACTS": "Усі контакти",
    "TAGGED_WITH": "З тегами",
    "NEW_LABEL": "Нова мітка",
    "NEW_TEAM": "Нова команда",
    "NEW_INBOX": "Нове джерело",
    "REPORTS_CONVERSATION": "Бесіди",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "WHATSAPP": "WhatsApp",
    "CAMPAIGNS": "Розсилки",
    "ONGOING": "У процесі",
    "ONE_OFF": "Один з",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Бот",
    "REPORTS_AGENT": "Агенти",
    "REPORTS_LABEL": "Мітки",
    "REPORTS_INBOX": "Канал",
    "REPORTS_TEAM": "Команда",
    "AGENT_ASSIGNMENT": "Agent Assignment",
    "SET_AVAILABILITY_TITLE": "Позначити себе як",
    "SET_YOUR_AVAILABILITY": "Встановіть доступність",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Огляд",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Довідковий центр",
      "ARTICLES": "Articles",
      "CATEGORIES": "Категорії",
      "LOCALES": "Locales",
      "SETTINGS": "Налаштування"
    },
    "CHANNELS": "Канали",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Позначити не в мережі (auto)",
      "INFO_TEXT": "Дозволити системі автоматично позначати як не в мережі коли ви не використовуєте програму або панель управління.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "SORT_TOOLTIP": "Сортувати",
    "SORT_BY": "Сортувати за",
    "SORT_GROUPS": {
      "CREATED": "Sort by date of creation",
      "ALPHABETICAL": "Sort in alphabetical order",
      "UNREAD_COUNT": "Sort by unread count"
    },
    "SORT_OPTIONS": {
      "CREATED_DESC": "Newest first",
      "CREATED_ASC": "Oldest first",
      "ALPHABETICAL_ASC": "Ascending (A - Z)",
      "ALPHABETICAL_DESC": "Descending (Z - A)",
      "UNREAD_COUNT_DESC": "Highest first",
      "UNREAD_COUNT_ASC": "Lowest first"
    },
    "DOCS": "Читати документи",
    "SECURITY": "Security",
    "CAPTAIN_AI": "Captain",
    "CONVERSATION_WORKFLOW": "Conversation Workflow"
  },
  "DATA_IMPORTS": {
    "HEADER": "Data",
    "DESCRIPTION": "Bring your existing contacts and past conversations into this account from another support tool. Each import runs in the background, so you can keep working while it finishes, track its progress, and review anything that was skipped along the way.",
    "LOADING": "Fetching imports",
    "DEFAULT_IMPORT_NAME": "Intercom import",
    "TABS": {
      "IMPORT": "Імпорт",
      "EXPORT": "Експорт"
    },
    "TYPES": {
      "CONTACTS": "Контакти",
      "CONVERSATIONS": "Бесіди",
      "MESSAGES": "Текст повідомлень"
    },
    "DRAWER": {
      "TITLE": "New import",
      "SOURCE": "Source",
      "NAME": "Import name",
      "NAME_PLACEHOLDER": "July Intercom migration",
      "ACCESS_KEY": "Intercom access key",
      "ACCESS_KEY_PLACEHOLDER": "Paste your Intercom access key",
      "DATA_TYPES": "Data to import",
      "VALIDATING": "Validating access key...",
      "VALID_KEY": "Access key validated.",
      "INVALID_KEY": "Could not validate this access key.",
      "ACTIVE_IMPORT": "Wait for the active import to finish before starting another one.",
      "CANCEL": "Скасувати",
      "IMPORT": "Імпорт"
    },
    "EXPORT": {
      "TITLE": "Exports are on the way",
      "DESCRIPTION": "Export your contacts and conversations out of this account. This workflow is coming soon.",
      "COMING_SOON": "Coming soon"
    },
    "TABLE": {
      "TITLE": "Recent imports",
      "EMPTY": "No imports yet",
      "EMPTY_DESCRIPTION": "Start an import to bring your existing customer history into this account.",
      "NEW_IMPORT": "Імпорт",
      "COUNT": "{count} imports",
      "UNNAMED": "Untitled import",
      "IMPORTED_COUNT": "{count} imported",
      "VIEW": "View import",
      "NAME": "Ім'я",
      "TYPE": "Тип",
      "STATUS": "Статус",
      "IMPORTED": "Imported",
      "CREATED": "Створено",
      "ABANDON": "Abandon"
    },
    "DETAIL": {
      "BACK": "Back to imports",
      "ERRORS": "Errors",
      "SKIP_LOGS": "Skip logs",
      "SOURCE": "Source",
      "IMPORT_TYPES": "Import types",
      "CREATED": "Створено",
      "DURATION": "Тривалість",
      "INITIATED_BY": "Started by",
      "PROGRESS": "Import progress",
      "PROGRESS_WITH_TOTAL": "{imported} of {total} imported",
      "PROGRESS_WITHOUT_TOTAL": "{imported} imported",
      "PROGRESS_OF_TOTAL": "of {total} imported",
      "PROGRESS_IMPORTED": "imported",
      "LAST_UPDATED_TOOLTIP": "Last updated {time}",
      "NO_SKIP_LOGS": "No skipped or failed records recorded.",
      "DOWNLOAD_SKIP_LOGS": "Download CSV",
      "DOWNLOAD_ERROR_LOGS": "Download CSV",
      "ALL_SKIP_LOGS": "Всі",
      "KIND": "Kind",
      "NO_ERRORS": "No errors recorded.",
      "ERROR_CODE": "Code",
      "SOURCE_OBJECT": "Source object",
      "MESSAGE": "Текст повідомлення"
    },
    "MONITOR": {
      "LIVE": "Live updates every {seconds}s",
      "LAST_UPDATED": "Last updated {time}",
      "REFRESH": "Оновити",
      "REFRESHING": "Refreshing",
      "STAGES": {
        "unknown": "Waiting for update",
        "queued": "Queued",
        "contacts": "Importing contacts",
        "conversations": "Importing conversations",
        "finalizing": "Finalizing import",
        "completed": "Завершено",
        "completed_with_errors": "Completed with errors",
        "failed": "Failed",
        "abandoned": "Abandoned"
      }
    },
    "ALERTS": {
      "IMPORT_STARTED": "Intercom import has started.",
      "IMPORT_ABANDONED": "Intercom import has been abandoned.",
      "IMPORT_FAILED": "Could not start the Intercom import."
    }
  },
  "CAPTAIN_SETTINGS": {
    "TITLE": "Captain Settings",
    "DESCRIPTION": "Configure your AI models and features for Captain. Captain follows a credit based billing, you will be charged credits for every action Captain takes based on the model selected.",
    "LOADING": "Loading Captain configuration...",
    "LINK_TEXT": "Learn more about Captain Credits",
    "NOT_ENABLED": "Captain is not enabled for your account. Please upgrade your plan to access Captain features.",
    "MODEL_CONFIG": {
      "TITLE": "Model Configuration",
      "DESCRIPTION": "Select AI models for different features.",
      "SELECT_MODEL": "Select model",
      "CREDITS_PER_MESSAGE": "{credits} credit/message",
      "COMING_SOON": "Coming soon",
      "EDITOR": {
        "TITLE": "Editor Features",
        "DESCRIPTION": "Powers smart compose, grammar corrections, tone adjustments, and content enhancement in your message editor."
      },
      "ASSISTANT": {
        "TITLE": "Assistant",
        "DESCRIPTION": "Handles automated responses, conversation summaries, and intelligent reply suggestions for customer interactions."
      },
      "COPILOT": {
        "TITLE": "Co-pilot",
        "DESCRIPTION": "Provides real-time contextual suggestions, knowledge base recommendations, and proactive insights during conversations."
      }
    },
    "FEATURES": {
      "TITLE": "Особливості",
      "DESCRIPTION": "Enable or disable AI-powered features.",
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Audio Transcription",
        "DESCRIPTION": "Automatically convert voice messages and call recordings into searchable text transcripts.",
        "MODEL_TITLE": "Audio Transcription Model",
        "MODEL_DESCRIPTION": "Select the AI model to use for converting audio messages into text transcripts"
      },
      "HELP_CENTER_SEARCH": {
        "TITLE": "Help Center Search Indexing",
        "DESCRIPTION": "Use AI for context aware search inside your help center articles."
      },
      "LABEL_SUGGESTION": {
        "TITLE": "Label Suggestion",
        "DESCRIPTION": "Automatically suggest relevant labels and tags for conversations based on content analysis and context.",
        "MODEL_TITLE": "Label Suggestion Model",
        "MODEL_DESCRIPTION": "Select the AI model to use for analyzing conversations and suggesting appropriate labels"
      }
    },
    "API": {
      "SUCCESS": "Captain settings updated successfully.",
      "ERROR": "Failed to update Captain settings. Please try again."
    }
  },
  "BILLING_SETTINGS": {
    "TITLE": "Біллінг",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Поточний План",
      "PLAN_NOTE": "Зараз ви підписані на **{plan}** план з **{quantity}** ліцензій",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on",
      "CURRENCY": "Currency"
    },
    "CURRENCY": {
      "SELECT": {
        "TITLE": "Choose your billing currency",
        "DESCRIPTION": "Select the currency you'd like to be billed in. This can't be changed once your subscription is created."
      },
      "OPTIONS": {
        "USD": "US Dollar (USD)",
        "BRL": "Brazilian Real (BRL)"
      }
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Керування підпискою",
      "DESCRIPTION": "Перегляньте попередні рахунки, відредагуйте платіжні реквізити, або скасуйте вашу підписку.",
      "BUTTON_TXT": "Перейти на портал для платежів"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more.",
      "REFRESH_CREDITS": "Оновити"
    },
    "CHAT_WITH_US": {
      "TITLE": "Потрібна допомога?",
      "DESCRIPTION": "Чи зіткнулися ви з питаннями у рахунках? Ми тут, щоб допомогти.",
      "BUTTON_TXT": "Почніть розмову з нами"
    },
    "NO_BILLING_USER": "Ваш платіжний обліковий запис налаштовується. Будь ласка, оновіть сторінку та повторіть спробу.",
    "TOPUP": {
      "BUY_CREDITS": "Buy more credits",
      "MODAL_TITLE": "Buy AI Credits",
      "MODAL_DESCRIPTION": "Purchase additional credits for Captain AI.",
      "CREDITS": "CREDITS",
      "ONE_TIME": "one-time",
      "POPULAR": "Most Popular",
      "NOTE_TITLE": "Замітка:",
      "NOTE_DESCRIPTION": "Credits are added immediately and expire in 6 months. An active subscription is required to use credits. Purchased credits are consumed after your monthly plan credits.",
      "CANCEL": "Скасувати",
      "PURCHASE": "Purchase Credits",
      "LOADING": "Loading options...",
      "FETCH_ERROR": "Failed to load credit options. Please try again.",
      "RETRY": "Retry",
      "PURCHASE_ERROR": "Failed to process purchase. Please try again.",
      "PURCHASE_SUCCESS": "Successfully added {credits} credits to your account",
      "CONFIRM": {
        "TITLE": "Confirm Purchase",
        "DESCRIPTION": "You are about to purchase {credits} credits for {amount}.",
        "INSTANT_DEDUCTION_NOTE": "Your saved card will be charged immediately upon confirmation.",
        "GO_BACK": "Повернутися",
        "CONFIRM_PURCHASE": "Confirm Purchase"
      }
    }
  },
  "SECURITY_SETTINGS": {
    "TITLE": "Security",
    "DESCRIPTION": "Manage your account security settings.",
    "LINK_TEXT": "Learn more about SAML SSO",
    "SAML_DISABLED_MESSAGE": "SAML SSO is currently disabled. Please contact your administrator to enable this feature.",
    "SAML": {
      "TITLE": "SAML SSO",
      "NOTE": "Configure SAML single sign-on for your account. Users will authenticate through your identity provider instead of using email/password.",
      "ACS_URL": {
        "LABEL": "ACS URL",
        "TOOLTIP": "Assertion Consumer Service URL - Configure this URL in your IdP as the destination for SAML responses"
      },
      "SSO_URL": {
        "LABEL": "SSO URL",
        "HELP": "The URL where SAML authentication requests will be sent",
        "PLACEHOLDER": "https://your-idp.com/saml/sso"
      },
      "CERTIFICATE": {
        "LABEL": "Signing certificate in PEM format",
        "HELP": "The public certificate from your identity provider used to verify SAML responses",
        "PLACEHOLDER": "-----BEGIN CERTIFICATE-----\nMIIC..."
      },
      "FINGERPRINT": {
        "LABEL": "Fingerprint",
        "TOOLTIP": "SHA-1 fingerprint of the certificate - Use this to verify the certificate in your IdP configuration"
      },
      "COPY_SUCCESS": "Код скопійований в буфер обміну",
      "SP_ENTITY_ID": {
        "LABEL": "SP Entity ID",
        "HELP": "Unique identifier for this application as a service provider (auto-generated).",
        "TOOLTIP": "Unique identifier for Chatwoot as the Service Provider - Configure this in your IdP settings"
      },
      "IDP_ENTITY_ID": {
        "LABEL": "Identity Provider Entity ID",
        "HELP": "Unique identifier for your identity provider (usually found in IdP configuration)",
        "PLACEHOLDER": "https://your-idp.com/saml"
      },
      "UPDATE_BUTTON": "Update SAML Settings",
      "API": {
        "SUCCESS": "SAML settings updated successfully",
        "ERROR": "Failed to update SAML settings",
        "ERROR_LOADING": "Failed to load SAML settings",
        "DISABLED": "SAML settings disabled successfully"
      },
      "VALIDATION": {
        "REQUIRED_FIELDS": "SSO URL, Identity Provider Entity ID, and Certificate are required fields",
        "SSO_URL_ERROR": "Please enter a valid SSO URL",
        "CERTIFICATE_ERROR": "Certificate is required",
        "IDP_ENTITY_ID_ERROR": "Identity Provider Entity ID is required"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "The SAML SSO feature is only available in the Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade to an Enterprise plan to access SAML single sign-on and other advanced security features.",
        "ASK_ADMIN": "Будь ласка, зверніться до адміністратора для оновлення."
      },
      "PAYWALL": {
        "TITLE": "Upgrade to enable SAML SSO",
        "AVAILABLE_ON": "The SAML SSO feature is only available in the Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade your plan to get access to SAML single sign-on and other advanced features.",
        "UPGRADE_NOW": "Оновити зараз",
        "CANCEL_ANYTIME": "Ви можете змінити або скасувати план у будь-який час"
      },
      "ATTRIBUTE_MAPPING": {
        "TITLE": "SAML Attribute Setup",
        "DESCRIPTION": "The following attribute mappings must be configured in your identity provider"
      },
      "INFO_SECTION": {
        "TITLE": "Service Provider Information",
        "TOOLTIP": "Copy these values and configure them in your Identity Provider to establish the SAML connection"
      }
    }
  },
  "CONVERSATION_WORKFLOW": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Conversation Workflows",
        "DESCRIPTION": "Configure rules and required fields for conversation resolution."
      }
    },
    "REQUIRED_ATTRIBUTES": {
      "TITLE": "Attributes required on resolution",
      "DESCRIPTION": "When resolving a conversation, agents will be prompted to fill these attributes if they haven't yet.",
      "NO_ATTRIBUTES": "No attributes added yet",
      "ADD": {
        "TITLE": "Add Attributes",
        "SEARCH_PLACEHOLDER": "Атрибути пошуку"
      },
      "SAVE": {
        "SUCCESS": "Required attributes updated",
        "ERROR": "Could not update required attributes, please try again"
      },
      "MODAL": {
        "TITLE": "Закрити розмову",
        "DESCRIPTION": "Please fill in the following custom attributes before resolving this conversation",
        "ACTIONS": {
          "RESOLVE": "Закрити розмову",
          "CANCEL": "Скасувати"
        },
        "PLACEHOLDERS": {
          "TEXT": "Write a note...",
          "NUMBER": "Enter a number",
          "LINK": "Add a link",
          "DATE": "Pick a date",
          "LIST": "Select an option"
        },
        "CHECKBOX": {
          "YES": "Так",
          "NO": "Ні"
        }
      },
      "PAYWALL": {
        "TITLE": "Upgrade to use required attributes",
        "AVAILABLE_ON": "The required conversation attributes feature is available on the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade your plan to prompt agents to fill required attributes before conversation resolution.",
        "UPGRADE_NOW": "Оновити зараз",
        "CANCEL_ANYTIME": "Ви можете змінити або скасувати план у будь-який час"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "The required conversation attributes feature is available on the paid plans.",
        "UPGRADE_PROMPT": "Upgrade to a paid plan to enforce required attributes before conversation resolution.",
        "ASK_ADMIN": "Будь ласка, зверніться до адміністратора для оновлення."
      }
    }
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Ой! Ми не змогли знайти жодного облікового запису Chatwoot. Будь ласка, створіть новий обліковий запис, щоб продовжити.",
    "NEW_ACCOUNT": "Новий акаунт",
    "SELECTOR_SUBTITLE": "Створити новий обліковий запис",
    "API": {
      "SUCCESS_MESSAGE": "Обліковий запис створено",
      "EXIST_MESSAGE": "Обліковий запис вже існує",
      "ERROR_MESSAGE": "Не вдалося підключитися до Woot Server, спробуйте ще раз пізніше"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Назва компанії",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Додати",
      "CANCEL": "Скасувати"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Переглянути всі шорткоди",
    "TITLE": {
      "OPEN_CONVERSATION": "Відкрити розмову",
      "RESOLVE_AND_NEXT": "Вирішити і перейти до наступного",
      "NAVIGATE_DROPDOWN": "Навігація випадаючих елементів",
      "RESOLVE_CONVERSATION": "Вирішити розмову",
      "GO_TO_CONVERSATION_DASHBOARD": "Перейти до панелі керування бесід",
      "ADD_ATTACHMENT": "Додати вкладення",
      "GO_TO_CONTACTS_DASHBOARD": "Перейти до панелі керування контактами",
      "TOGGLE_SIDEBAR": "Перемикач бічної панелі",
      "GO_TO_REPORTS_SIDEBAR": "Перейти до бічної панелі звітів",
      "MOVE_TO_NEXT_TAB": "Перейти до наступної вкладки в списку бесід",
      "GO_TO_SETTINGS": "Перейти до налаштувань",
      "SWITCH_TO_PRIVATE_NOTE": "Перейти до приватних заміток",
      "SWITCH_TO_REPLY": "Перейти до відповіді",
      "TOGGLE_SNOOZE_DROPDOWN": "Перемкнути випадаючий список відкладення"
    }
  },
  "ASSIGNMENT_POLICY": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Agent assignment",
        "DESCRIPTION": "Define policies to effectively manage workload and route conversations based on the needs of inboxes and agents. Learn more here"
      },
      "ASSIGNMENT_POLICY": {
        "TITLE": "Assignment policy",
        "DESCRIPTION": "Manage how conversations get assigned in inboxes.",
        "FEATURES": [
          "Assign by conversations evenly or by available capacity",
          "Add fair distribution rules to avoid overloading any agent",
          "Add inboxes to a policy - one policy per inbox"
        ]
      },
      "AGENT_CAPACITY_POLICY": {
        "TITLE": "Agent capacity policy",
        "DESCRIPTION": "Manage workload for agents.",
        "FEATURES": [
          "Define maximum conversations per inbox",
          "Create exceptions based on labels and time",
          "Add agents to a policy - one policy per agent"
        ]
      }
    },
    "AGENT_ASSIGNMENT_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Assignment policy",
          "CREATE_POLICY": "New policy"
        },
        "CARD": {
          "ORDER": "Order",
          "PRIORITY": "Пріоритет",
          "ACTIVE": "Активний",
          "INACTIVE": "Inactive",
          "POPOVER": "Added inboxes",
          "EDIT": "Редагувати"
        },
        "NO_RECORDS_FOUND": "No assignment policies found"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Create assignment policy"
        },
        "CREATE_BUTTON": "Create policy",
        "API": {
          "SUCCESS_MESSAGE": "Assignment policy created successfully",
          "ERROR_MESSAGE": "Failed to create assignment policy",
          "INBOX_LINKED": "Inbox has been linked to the policy"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Edit assignment policy"
        },
        "EDIT_BUTTON": "Update policy",
        "CONFIRM_ADD_INBOX_DIALOG": {
          "TITLE": "Add inbox",
          "DESCRIPTION": "{inboxName} inbox is already linked to another policy. Are you sure you want to link it to this policy? It will be unlinked from the other policy.",
          "CONFIRM_BUTTON_LABEL": "Continue",
          "CANCEL_BUTTON_LABEL": "Скасувати"
        },
        "INBOX_LINK_PROMPT": {
          "TITLE": "Link inbox to policy",
          "DESCRIPTION": "Would you like to link this inbox to the assignment policy?",
          "LINK_BUTTON": "Link inbox",
          "CANCEL_BUTTON": "Skip"
        },
        "API": {
          "SUCCESS_MESSAGE": "Assignment policy updated successfully",
          "ERROR_MESSAGE": "Failed to update assignment policy"
        },
        "INBOX_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Inbox added to policy successfully",
            "ERROR_MESSAGE": "Failed to add inbox to policy"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Inbox removed from policy successfully",
            "ERROR_MESSAGE": "Failed to remove inbox from policy"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Policy name:",
          "PLACEHOLDER": "Enter policy name"
        },
        "DESCRIPTION": {
          "LABEL": "Опис:",
          "PLACEHOLDER": "Enter description"
        },
        "STATUS": {
          "LABEL": "Статус:",
          "PLACEHOLDER": "Select status",
          "ACTIVE": "Policy is active",
          "INACTIVE": "Policy is inactive"
        },
        "ASSIGNMENT_ORDER": {
          "LABEL": "Assignment order",
          "ROUND_ROBIN": {
            "LABEL": "Round robin",
            "DESCRIPTION": "Assign conversations evenly among agents."
          },
          "BALANCED": {
            "LABEL": "Balanced",
            "DESCRIPTION": "Assign conversations based on available capacity.",
            "PREMIUM_MESSAGE": "Upgrade to access balanced assignment and agent capacity management.",
            "PREMIUM_BADGE": "Premium"
          }
        },
        "ASSIGNMENT_PRIORITY": {
          "LABEL": "Assignment priority",
          "EARLIEST_CREATED": {
            "LABEL": "Earliest created",
            "DESCRIPTION": "The conversation that was created first gets assigned first."
          },
          "LONGEST_WAITING": {
            "LABEL": "Longest waiting",
            "DESCRIPTION": "The conversation waiting the longest gets assigned first."
          }
        },
        "FAIR_DISTRIBUTION": {
          "LABEL": "Fair distribution policy",
          "DESCRIPTION": "Set the maximum number of conversations that can be assigned per agent within a time window to avoid overloading any one agent. This required field defaults to 100 conversations per hour.",
          "INPUT_MAX": "Assign max",
          "DURATION": "Conversations per agent in every"
        },
        "EXCLUDE_OLDER_THAN": {
          "LABEL": "Skip stale conversations",
          "DESCRIPTION": "Skip unassigned conversations older than this. Defaults to 7 days; clear to disable."
        },
        "INBOXES": {
          "LABEL": "Added inboxes",
          "DESCRIPTION": "Add inboxes for which this policy will be applicable.",
          "ADD_BUTTON": "Add inbox",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Виберіть канали для додавання",
            "ADD_BUTTON": "Додати"
          },
          "EMPTY_STATE": "No inboxes added to this policy, add an inbox to get started",
          "API": {
            "SUCCESS_MESSAGE": "Inbox successfully added to policy",
            "ERROR_MESSAGE": "Failed to add inbox to policy"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Assignment policy deleted successfully",
        "ERROR_MESSAGE": "Failed to delete assignment policy"
      }
    },
    "AGENT_CAPACITY_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Agent capacity",
          "CREATE_POLICY": "New policy"
        },
        "CARD": {
          "POPOVER": "Added agents",
          "EDIT": "Редагувати"
        },
        "NO_RECORDS_FOUND": "No agent capacity policies found"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Create agent capacity policy"
        },
        "CREATE_BUTTON": "Create policy",
        "API": {
          "SUCCESS_MESSAGE": "Agent capacity policy created successfully",
          "ERROR_MESSAGE": "Failed to create agent capacity policy"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Edit agent capacity policy"
        },
        "EDIT_BUTTON": "Update policy",
        "CONFIRM_ADD_AGENT_DIALOG": {
          "TITLE": "Add agent",
          "DESCRIPTION": "{agentName} is already linked to another policy. Are you sure you want to link it to this policy? It will be unlinked from the other policy.",
          "CONFIRM_BUTTON_LABEL": "Continue",
          "CANCEL_BUTTON_LABEL": "Скасувати"
        },
        "API": {
          "SUCCESS_MESSAGE": "Agent capacity policy updated successfully",
          "ERROR_MESSAGE": "Failed to update agent capacity policy"
        },
        "AGENT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Agent added to policy successfully",
            "ERROR_MESSAGE": "Failed to add agent to policy"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Agent removed from policy successfully",
            "ERROR_MESSAGE": "Failed to remove agent from policy"
          }
        },
        "INBOX_LIMIT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Inbox limit added successfully",
            "ERROR_MESSAGE": "Failed to add inbox limit"
          },
          "UPDATE": {
            "SUCCESS_MESSAGE": "Inbox limit updated successfully",
            "ERROR_MESSAGE": "Failed to update inbox limit"
          },
          "DELETE": {
            "SUCCESS_MESSAGE": "Inbox limit deleted successfully",
            "ERROR_MESSAGE": "Failed to delete inbox limit"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Policy name:",
          "PLACEHOLDER": "Enter policy name"
        },
        "DESCRIPTION": {
          "LABEL": "Опис:",
          "PLACEHOLDER": "Enter description"
        },
        "INBOX_CAPACITY_LIMIT": {
          "LABEL": "Inbox capacity limits",
          "ADD_BUTTON": "Add inbox",
          "FIELD": {
            "SELECT_INBOX": "Select inbox",
            "MAX_CONVERSATIONS": "Max conversations",
            "SET_LIMIT": "Set limit"
          },
          "EMPTY_STATE": "No inbox limit set"
        },
        "EXCLUSION_RULES": {
          "LABEL": "Exclusion rules",
          "DESCRIPTION": "Conversations that satisfy the following conditions would not count towards agent capacity",
          "TAGS": {
            "LABEL": "Exclude conversations tagged with specific labels",
            "ADD_TAG": "add tag",
            "DROPDOWN": {
              "SEARCH_PLACEHOLDER": "Виберіть мітки для додавання"
            },
            "EMPTY_STATE": "No tags added to this policy."
          },
          "DURATION": {
            "LABEL": "Exclude conversations older than a specified duration",
            "PLACEHOLDER": "Set time"
          }
        },
        "USERS": {
          "LABEL": "Assigned agents",
          "DESCRIPTION": "Add agents for which this policy will be applicable.",
          "ADD_BUTTON": "Add agent",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Виберіть агентів для додавання",
            "ADD_BUTTON": "Додати"
          },
          "EMPTY_STATE": "No agents added",
          "API": {
            "SUCCESS_MESSAGE": "Agent successfully added to policy",
            "ERROR_MESSAGE": "Failed to add agent to policy"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Agent capacity policy deleted successfully",
        "ERROR_MESSAGE": "Failed to delete agent capacity policy"
      }
    },
    "DELETE_POLICY": {
      "TITLE": "Delete policy",
      "DESCRIPTION": "Are you sure you want to delete this policy? This action cannot be undone.",
      "CONFIRM_BUTTON_LABEL": "Видалити",
      "CANCEL_BUTTON_LABEL": "Скасувати"
    }
  }
}
